import { render, staticRenderFns } from "./PageSlug.vue?vue&type=template&id=41b6aa68&scoped=true&lang=pug&"
import script from "./PageSlug.vue?vue&type=script&lang=js&"
export * from "./PageSlug.vue?vue&type=script&lang=js&"
import style0 from "./PageSlug.vue?vue&type=style&index=0&id=41b6aa68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b6aa68",
  null
  
)

export default component.exports